import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

const token = localStorage.getItem('dt_token');
if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default api;
